module.exports = __webpack_public_path__ + "img/phone.4f4eea54.svg";